import React from 'react'
import { makeStyles } from '@material-ui/styles';
import { Typography, Grid, Card } from '@material-ui/core';
import SimpleCheckbox from './SimpleCheckbox'
import FormControlCheckBoxes from './FormControlCheckBoxes'
import FormGroupCheckBoxes from './FormGroupCheckBoxes'
import CheckBoxPositions from './CheckBoxPositions'

const useStyles = makeStyles(theme => ({

    root: {
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
    },
    gridContainerOuter: {
        margin: '6px -6px',
        display: 'flex',
        justifyContent: 'center'
    },
    gridItemInner: {
        padding: '0px 6px'
    },
    titleDiv: {
        padding: '8px 0px 12px 0px'
    },
    divTitle: {
        padding: 14,
        borderBottom: '1px solid lightgrey'
    },
    divContent: {
        padding: 12,
    },
}));

function CheckBoxes() {
    const classes = useStyles();
    return (
        <div className={classes.root}>
            <div className={classes.titleDiv}>
                <Typography variant="h2">CheckBoxes</Typography>
            </div>

            <Grid container className={classes.gridContainerOuter}>
                <Grid item xs={12} className={classes.gridItemInner}>
                    <Card className={classes.cardBody}>
                        <div className={classes.divTitle}>
                            <Typography variant="h5" color="inherit">
                                Simple checkboxes
                            </Typography>
                        </div>
                        <div className={classes.divContent}>
                            <SimpleCheckbox />
                        </div>
                    </Card>
                </Grid>

            </Grid>
            <Grid container className={classes.gridContainerOuter}>
                <Grid item xs={12} className={classes.gridItemInner}>
                    <Card className={classes.cardBody}>
                        <div className={classes.divTitle}>
                            <Typography variant="h5" color="inherit">
                                Form control checkboxes
                            </Typography>
                        </div>
                        <div className={classes.divContent}>
                            <FormControlCheckBoxes />
                        </div>
                    </Card>
                </Grid>

            </Grid>

            <Grid container className={classes.gridContainerOuter}>
                <Grid item xs={12} className={classes.gridItemInner}>
                    <Card className={classes.cardBody}>
                        <div className={classes.divTitle}>
                            <Typography variant="h5" color="inherit">
                                FormGroup Checkboxes
                            </Typography>
                        </div>
                        <div className={classes.divContent}>
                            <FormGroupCheckBoxes />
                        </div>
                    </Card>
                </Grid>

            </Grid>

            <Grid container className={classes.gridContainerOuter}>
                <Grid item xs={12} className={classes.gridItemInner}>
                    <Card className={classes.cardBody}>
                        <div className={classes.divTitle}>
                            <Typography variant="h5" color="inherit">
                                Label Positions
                            </Typography>
                        </div>
                        <div className={classes.divContent}>
                            <CheckBoxPositions />
                        </div>
                    </Card>
                </Grid>

            </Grid>

        </div>

    )
}

export default CheckBoxes
